import { createSlice } from '@reduxjs/toolkit'
import {getFactoryCities, getFactoryTerminationCities} from "./thunks"
import { logOut } from '../authentication/authenticationSlice';

const initialState= {
  factoryCities:{
    cities: [], 
    loading: "idle",
    error: null 
  },
  terminationCities:{
    cities: [], 
    loading: "idle",
    error: null 
  } 
}

const factoryCitiesSlice = createSlice({
  name: 'factoryCities',
  initialState,
  reducers: {
    clearProvinceError: (state)=>{
      state.factoryCities.error = null
      state.factoryCities.loading = "idle"
    }
  },
  extraReducers: {
    [getFactoryCities.pending]: (state) => {
        state.factoryCities.loading = "loading"; 
        state.factoryCities.error = null
      },
    [getFactoryCities.fulfilled]: (state, action) => {
    state.factoryCities.loading = "succeeded";
    state.factoryCities.cities = action.payload
      
    },
    [getFactoryCities.rejected]: (state, action) => {
        state.factoryCities.loading = "failed"; 
        state.factoryCities.error = action.error.message
      },
    [getFactoryTerminationCities.pending]: (state) => {
        state.terminationCities.loading = "loading"; 
        state.terminationCities.error = null
      },
    [getFactoryTerminationCities.fulfilled]: (state, action) => {
    state.terminationCities.loading = "succeeded";
    state.terminationCities.cities = action.payload
      
    },
    [getFactoryTerminationCities.rejected]: (state, action) => {
        state.terminationCities.loading = "failed"; 
        state.terminationCities.error = action.error.message
      },
    [logOut]: (state)=> initialState
  }
})

export const {clearProvinceError} = factoryCitiesSlice.actions;
export default factoryCitiesSlice.reducer
